__turbopack_context__.v({
  "action": "LeaderboardEmptyState-module-scss-module__9Tw9xG__action",
  "description": "LeaderboardEmptyState-module-scss-module__9Tw9xG__description",
  "illustration": "LeaderboardEmptyState-module-scss-module__9Tw9xG__illustration",
  "root": "LeaderboardEmptyState-module-scss-module__9Tw9xG__root",
  "text": "LeaderboardEmptyState-module-scss-module__9Tw9xG__text",
  "title": "LeaderboardEmptyState-module-scss-module__9Tw9xG__title",
});
